<template>
    <div>
        <div class="warpperImg">
            <div id="leftImage" ref="leftImage" @mouseover="onMouserover" @mouseout="onMouseout" @mousemove="onMousemove">
                <img id="minImg" ref="minImg" :src="checkedImage.filePath" alt="托盘,买托盘,托盘租赁,普拉托托盘共享" />
                <span id="shadow" ref="shadow"></span>
            </div>
            <div id="rightImage" ref="rightImage" v-if="checkedImage.imgProps">
                <img id="maxImg" ref="maxImg" :src="checkedImage.imgProps.enlarge_img" alt="托盘,买托盘,托盘租赁,普拉托托盘共享">
            </div>
            <div class="image">
                <swiper class="swiper" :options="swiperOption">
                    <swiper-slide v-for="(image, index) in imageList" :key="image.imageId">
                        <div :class="['plt-swiper',checkedImage.filePath == image.filePath ? 'activeBorder' : '' ]" @mouseover="onChangeImg(index)">
                            <img :src="image.filePath" />
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiperBut">
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    props: {
        imageList: Array,
    },
    components: {
        Swiper,
        SwiperSlide
    },
    watch: {
        imageList: {
            handler(newVal) {
                if (newVal)
                    this.checkedImage = this.imageList[0];
            },
            immediate: true,
            deep: true,
        }
    },
    data() {
        return {
            checkedImage: this.imageList[0],
            swiperOption: {
                slidesPerView: 4,
                spaceBetween: 8,
                slidesPerGroup: 4,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
            leftImage: "",
            shadow: "",
            minImg: "",
            rightImage: "",
            maxImg: ""
        }
    },
    mounted() {
        this.checkedImage = this.imageList[0];
    },
    methods: {
        onChangeImg(index) {
            this.checkedImage = this.imageList[index];
        },
        // 鼠标移入
        onMouserover() {
            this.shadow = this.$refs['shadow'];
            this.rightImage = this.$refs['rightImage'];
            if (this.checkedImage.imgProps) {
                this.shadow.style.display = "block";
                this.rightImage.style.display = "block";
                this.leftImage.style.cursor = "move";
            } else {
                this.leftImage.style.cursor = "default";
            }
        },
        // 移出
        onMouseout() {
            if (this.checkedImage.imgProps) {
                this.shadow.style.display = "none";
                this.rightImage.style.display = "none";
            }
        },
        //鼠标在小图片上滑动
        onMousemove(e) {
            if (this.checkedImage.imgProps) {

                this.leftImage = this.$refs['leftImage']
                this.maxImg = this.$refs['maxImg']

                // 鼠标距离小盒子距离=当前鼠标位置到可视区左侧的距离 - 小盒子距离可视区的距离-滑块宽度的一半
                let ev = e || window.event,
                    x = ev.clientX - this.leftImage.getBoundingClientRect().left - this.shadow.offsetWidth / 2,
                    y = ev.clientY - this.leftImage.getBoundingClientRect().top - this.shadow.offsetHeight / 2,
                    L = this.leftImage.offsetWidth - this.shadow.offsetWidth,
                    T = this.leftImage.offsetHeight - this.shadow.offsetHeight;
                if (x <= 0)
                    x = 0;
                else if (x >= L)
                    x = L - 2;

                if (y <= 0)
                    y = 0;
                else if (y >= T)
                    y = T - 2;

                this.shadow.style.left = x + 'px';
                this.shadow.style.top = y + 'px';
                //计算滑块和小盒子的的距离比例
                let scaleX = x / (this.leftImage.offsetWidth - this.shadow.offsetWidth);
                let scaleY = y / (this.leftImage.offsetHeight - this.shadow.offsetHeight);
                //设置右侧大图的左边定位距离。也就是滑块和小盒子的距离比乘以大图片的宽减去大盒子的值
                this.maxImg.style.left = -scaleX * (this.maxImg.offsetWidth - this.rightImage.offsetWidth) + "px";
                this.maxImg.style.top = -scaleY * (this.maxImg.offsetHeight - this.rightImage.offsetHeight) + "px";
            }

        }
    }
}
</script>
<style lang="scss" scoped>
.warpperImg {
    position: relative;

    #leftImage {
        width: 380px;
        height: 380px;
        border: 1px solid gainsboro;
        position: relative;
        margin-left: 30px;
        #shadow {
            width: 200px;
            height: 200px;
            background: #ff8800;
            opacity: 0.3;
            position: absolute;
            left: 0;
            top: 0;
            display: none;
        }
        img {
            width: 100%;
            height: 100%;
        }
    }
    #rightImage {
        width: 440px;
        height: 440px;
        border: 1px solid gainsboro;
        position: absolute;
        top: 0;
        left: 430px;
        z-index: 99;
        overflow: hidden;
        display: none;
        img {
            width: 820px;
            height: 820px;
            position: absolute;
            left: 0;
            top: 0;
        }
    }
    .image {
        width: 352px;
        height: 78px;
        margin-top: 10px;
        text-align: center;
        margin-left: 46px;
    }
}

.plt-swiper {
    width: 78px;
    height: 78px;
    border: 1px solid gainsboro;
    box-sizing: border-box;
    // margin-right: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    &:hover {
        border: 1px solid #ff9000;
    }
    img {
        width: 70px;
        height: 70px;
        transition: all 0.5s;
    }
    &:hover img {
        transform: scale(1.08);
    }
}
.swiper {
    padding-left: 5px;
}
.swiper-slide {
    width: 78px !important;
    height: 78px !important;
    margin-right: 10px !important;
}
.swiper-slide:nth-child(4) {
    margin-right: 0;
}
.swiperBut {
    width: 352px;
    position: relative;
}
.swiper-button-prev,
.swiper-button-next {
    width: 30px;
    height: 78px;
    background: #ffe8d0;
    color: #ff9000;
    outline: none;
}
.swiper-button-prev {
    position: absolute;
    top: -56px;
    left: -37px;
}
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
    border: 1px solid #c4c1c1;
    background: #fff;
    color: #c4c1c1;
}
.swiper-button-next {
    position: absolute;
    top: -56px;
    right: -34px;
}
.swiper-button-prev:after,
.swiper-button-next:after {
    font-size: 25px;
    font-weight: bold;
}
.activeBorder {
    border: 1px solid #ff9000;
}
</style>